import React from "react";
import PropTypes from "prop-types";
import { Icon, InlineStack, Text } from "@shopify/polaris";
import { ArrowDiagonalIcon, ChevronDownIcon } from "@shopify/polaris-icons";

const StatsCard = ({ label, value, trend, trendDirection, showMenu }) => {
  const isPositive = trendDirection === "up";

  return (
    <div className="operator-dashboard-stat-card">
      <InlineStack align="space-between" blockAlign="start">
        <Text as="p" variant="bodySm" tone="subdued" fontWeight="semibold" className="operator-dashboard-stat-label">
          {label}
        </Text>
        {showMenu && (
          <span className="operator-dashboard-stat-menu">
            <Icon source={ChevronDownIcon} tone="subdued" />
          </span>
        )}
      </InlineStack>
      <Text as="p" variant="headingLg" fontWeight="bold" className="operator-dashboard-stat-value">
        {value}
      </Text>
      <span
        className={`operator-dashboard-trend-badge ${
          isPositive ? "operator-dashboard-trend-badge--up" : "operator-dashboard-trend-badge--down"
        }`}
      >
        <span
          className={`operator-dashboard-trend-arrow ${
            !isPositive ? "operator-dashboard-trend-arrow--down" : ""
          }`}
          aria-hidden="true"
        >
          <Icon source={ArrowDiagonalIcon} />
        </span>
        <Text as="span" variant="bodySm" fontWeight="small">
          {trend}
        </Text>
      </span>
    </div>
  );
};

StatsCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  trend: PropTypes.string.isRequired,
  trendDirection: PropTypes.oneOf(["up", "down"]).isRequired,
  showMenu: PropTypes.bool,
};

StatsCard.defaultProps = {
  showMenu: false,
};

export default StatsCard;
